export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/ko.lyaml"));
at({ "ko": { "public": { "sampleString": "\uC0D8\uD50C \uBB38\uC790\uC5F4" } } });
};